import { t } from '@lingui/macro';

import { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest';
import { SeoSlugEnum } from '@rover/shared/js/constants/seo';

type SEO_SLUG_TO_STRING = Record<
  Exclude<
    SeoSlugEnum,
    SeoSlugEnum.DOG_TRAINING | SeoSlugEnum.DOG_SITTING | SeoSlugEnum.PET_BOARDING
  >,
  string
>;

export const getHardcodedContentForServiceTypeSlug = (
  seoSlug: ServiceTypeSlugEnum
): Record<'h2' | 'resultsH2' | 'priceTransparencyBannerText', string> => {
  const H2_HARDCODED_FOR_SEO_SLUG: SEO_SLUG_TO_STRING = {
    [SeoSlugEnum.DOG_BOARDING]: t`Find a loving dog sitter to watch your dog overnight at your sitter’s home.`,
    [SeoSlugEnum.DOG_WALKING]: t`Book a dog walker to give your dog a 30-minute walk around your neighborhood.`,
    [SeoSlugEnum.DOGGY_DAY_CARE]: t`Drop off your dog at your sitter’s home in the morning and pick them up in the evening.`,
    [SeoSlugEnum.HOUSE_SITTING]: t`Find a loving house sitter to watch over your pets and your home.`,
    [SeoSlugEnum.CAT_SITTING]: t`Book a cat sitter to stop by your home to feed and play with your cat.`,
    [SeoSlugEnum.PET_SITTING]: t`Book a pet sitter to stop by your home a few times a day to feed and play with your pet.`,
  };

  const RESULTS_H2_FOR_SEO_SLUG: SEO_SLUG_TO_STRING = {
    [SeoSlugEnum.DOG_BOARDING]: t`Loving dog sitters in your neighborhood`,
    [SeoSlugEnum.DOG_WALKING]: t`Loving dog walkers in your neighborhood`,
    [SeoSlugEnum.DOGGY_DAY_CARE]: t`Loving doggy day care in your neighborhood`,
    [SeoSlugEnum.HOUSE_SITTING]: t`Loving house sitters in your neighborhood`,
    [SeoSlugEnum.CAT_SITTING]: t`Loving cat sitters in your neighborhood`,
    [SeoSlugEnum.PET_SITTING]: t`Loving pet sitters in your neighborhood`,
  };

  const PRICE_TRANSPARENCY_BANNER_TEXT_FOR_SEO_SLUG: SEO_SLUG_TO_STRING = {
    [SeoSlugEnum.DOG_BOARDING]: t`The prices below are estimates per night **for 1 adult dog**, including fees. Pricing may vary based on your search.`,
    [SeoSlugEnum.DOG_WALKING]: t`The prices below are estimates per walk **for 1 adult dog**, including fees. Pricing may vary based on your search.`,
    [SeoSlugEnum.DOGGY_DAY_CARE]: t`The prices below are estimates per day **for 1 adult dog**, including fees. Pricing may vary based on your search.`,
    [SeoSlugEnum.HOUSE_SITTING]: t`The prices below are estimates per night **for 1 adult dog**, including fees. Pricing may vary based on your search.`,
    [SeoSlugEnum.CAT_SITTING]: t`The prices below are estimates per night **for 1 cat**, including fees. Pricing may vary based on your search.`,
    [SeoSlugEnum.PET_SITTING]: t`The prices below are estimates per visit **for 1 pet**, including fees. Pricing may vary based on your search.`,
  };

  return {
    h2: H2_HARDCODED_FOR_SEO_SLUG[seoSlug],
    resultsH2: RESULTS_H2_FOR_SEO_SLUG[seoSlug],
    priceTransparencyBannerText: PRICE_TRANSPARENCY_BANNER_TEXT_FOR_SEO_SLUG[seoSlug],
  };
};
